import React, { useEffect, useState } from "react";
import { CONTACT_MEDIUM, CONTACT_URL } from "../constant/constants";
import CopyrightComponent from "../component/CopyrightComponent";
import { useNavigate } from "react-router-dom";
import useUserStore from "../stores/store";
import ApiService from "../utils/ApiService";
import { ConfigProvider, Spin, Divider, Space, Input } from "antd";
import { registerDeviceToken } from "../services/notification-service";
import { getBranchIdOnMissedDefaultBranchId } from "../services/user-service";
import { fetchAndUpdateTableFloors } from "../services/order-table-base-service";
import { fetchAndstoreCoupons } from "../services/coupon-service";

function Login() {
  const [apiCalling, setApiCalling] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [validation, setValidation] = useState({});
  const { isLoggedIn, user, setUser } = useUserStore();
  const navigate = useNavigate();
  const [formPosition, setFormPosition] = useState({
    marginTop: "50px",
  });

  useEffect(() => {
    calculateCenter();
    if (isLoggedIn && user.isSuperAdmin) {
      navigate("/restaurants", { replace: true });
    } else if (isLoggedIn) {
      navigate("/dashboard", { replace: true });
    }
  }, [isLoggedIn, user]);

  const calculateCenter = () => {
    const loginFormHeight = document.getElementById("login-form").offsetHeight;
    const mainFormHeight = document.getElementById("main-form").offsetHeight;
    let freeHeight = (mainFormHeight - loginFormHeight) / 3;
    setFormPosition({
      marginTop: `${freeHeight}px`,
    });
  };

  const login = async () => {
    try {
      let errors = {};
      if (!phoneNumber) {
        errors["phone"] = "Phone No Required";
      }
      if (!password) {
        errors["password"] = "Password Required";
      }
      if (Object.keys(errors).length > 0) {
        setValidation(errors);
        return;
      }
      let params = {
        loginMode: "PASSWORD",
        countryCode: "880",
        phone: phoneNumber,
        otp: "",
        password: password,
      };
      setApiCalling(true);

      const res = await ApiService.LOGIN(params);

      if (res.code !== 200) {
        setValidation({ ...validation, error: res.data.message });
        setApiCalling(false);
        return;
      }

      const { payload } = res;


      if (payload.isSuperAdmin) {
        setUser(payload, null);
        navigate("/restaurants", { replace: true });
        setApiCalling(false);
        return;
      }

      const branchId = getBranchIdOnMissedDefaultBranchId(payload.defaultBranchId, payload.restaurants)

      if (branchId === "") {
        setValidation({
          ...validation,
          error: "We can't log you in. Please contact support.",
        });
        return;
      }

      const resRestaurantInfo = await ApiService.GET_RESTAURANT_INFO(
        { restaurantId: branchId },
        payload.token.token
      );

      if (resRestaurantInfo.code !== 200) {
        setValidation({ ...validation, error: resRestaurantInfo.data.message });
        setApiCalling(false);
        return;
      }

      const { record } = resRestaurantInfo.payload;
      setUser(payload, record);

      if (record.tableManagement === 'Active') {
        fetchAndUpdateTableFloors(branchId, payload.token.token);
      }

      registerDeviceToken();

      fetchAndstoreCoupons(branchId, payload.token.token)

      navigate("/dashboard", { replace: true });
    } catch (err) {
      console.log('Error: ', err);
      setValidation({ ...validation, error: "Failed to login. Please reload the page and try again." });
    } finally {
      setApiCalling(false);
    }
  };

  const forgetPassword = () => {
    navigate("/forget-password");
  };

  const updatePhone = (e) => {
    const val = e.target.value;

    if (val.length < 11 && /^\d*$/.test(val)) {
      setPhoneNumber(val);
    }
  };

  const handleContact = (contactMedium) => {
    switch (contactMedium) {
      case CONTACT_MEDIUM.CALL:
        window.open(`${CONTACT_URL.CALL_URL}`, "_blank", "noopener,noreferrer");
        break;
      case CONTACT_MEDIUM.WHATSAPP:
        window.open(`${CONTACT_URL.WHATSAPP_URL}`, "_blank", "noopener,noreferrer");
        break;
      case CONTACT_MEDIUM.MESSENGER:
        window.open(`${CONTACT_URL.MESSENGER_URL}`, "_blank", "noopener,noreferrer");
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (phoneNumber) {
      setValidation({});
    }
  }, [phoneNumber, password]);

  return (
    <div id="main-form" style={{ height: "100vh" }} className="flex flex-col items-center p-[50px] bg-yellow">
      <div
        id="login-form"
        style={formPosition}
        className="flex w-[360px] flex-col lg:w-[400px] bg-white justify-center border-[1px] border-gray-300 rounded-[5px] p-[20px]"
      >
        <div className="w-full h-[60px] flex flex-row mb-[10px] items-center justify-start gap-x-[5%]">
          <img className="w-auto h-full" src={`/images/icons/TableTap_icon.svg`} />
          <div className="w-auto h-full content-center">
            <img src={`/images/Scan_Order_Savor.png`} />
          </div>
        </div>
        <div className="text-red-700 ml-[20px] py-[8px] flex flex-col font-regular cursor-pointer">
          {Object.values(validation).map((item) => {
            return <div>{`* ${item}`}</div>;
          })}
        </div>

        <div className="w-full flex flex-col px-[16px] mb-[12px] text-sm">
          <div>
            Phone <span className="text-red-600 font-bold">*</span>
          </div>
          <div className="w-full">
            <Space.Compact className="w-full">
              <Input
                readOnly={true}
                style={{
                  width: "75px",
                }}
                defaultValue="+880"
              />
              <Input
                value={phoneNumber}
                onPressEnter={login}
                highlight={validation["phone"]}
                onChange={updatePhone}
                placeholder="e.g. 1715XXXXXX"
              />
            </Space.Compact>
          </div>
        </div>
        <div className="w-full flex flex-col px-[16px] mb-[12px] text-sm">
          <div>
            Password <span className="text-red-600 font-bold">*</span>
          </div>
          <div className="w-full">
            <Space direction="vertical" className="w-full">
              <Input.Password
                placeholder="write password"
                onPressEnter={login}
                highlight={validation["password"]}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required={true}
                className="h-[34px]"
              />
            </Space>
          </div>
        </div>

        <div className="flex flex-row px-[16px] mt-[8px] items-center">
          {apiCalling ? (
            <ConfigProvider
              theme={{
                components: {
                  Spin: {
                    colorPrimary: "#EE3169",
                  },
                },
              }}
            >
              <Spin size="medium" className="w-[66px] text-center items-center" />
            </ConfigProvider>
          ) : (
            <div
              className="bg-yellow text-black px-[12px] py-[8px] rounded-[5px] font-ubold cursor-pointer"
              onClick={login}
            >
              Login
            </div>
          )}
          <div className="text-black px-[12px] py-[8px] font-ulight underline cursor-pointer" onClick={forgetPassword}>
            Forgot Password?
          </div>
        </div>

        <div className="w-full px-[16px]">
          <Divider />

          <div className="text-center font-medium">Contact For Account</div>

          <div className="w-full h-[40px] mt-[10px] flex flex-row flex-nowrap items-center justify-center gap-x-[23px]">
            <div onClick={() => handleContact(CONTACT_MEDIUM.CALL)} className="w-[40px] h-full cursor-pointer">
              <img src={`/images/icons/call_icon.svg`} alt="Call Icon" />
            </div>

            <div className="w-[40px] h-full cursor-pointer" onClick={() => handleContact(CONTACT_MEDIUM.WHATSAPP)}>
              <img src={`/images/icons/whatsapp_icon.svg`} alt="Whatsapp Icon" />
            </div>

            <div className="w-[40px] h-full cursor-pointer" onClick={() => handleContact(CONTACT_MEDIUM.MESSENGER)}>
              <img src={`/images/icons/messenger_icon.svg`} alt="Messenger Icon" />
            </div>
          </div>
        </div>
      </div>

      <CopyrightComponent />
    </div>
  );
}

export default Login;
